<template>
  <v-select
    v-model="model"
    dense
    outlined
    item-text="nome"
    return-object
    :placeholder="placeholder"
    :label="label"
    :rules="[rules.required]"
    :items="items"
  />
</template>

<script>
import enderecoService from '@/services/sit-pedidos/endereco.service'

export default {
  name: 'StateSelect',

  props: {
    label: {
      type: String,
      required: true,
    },

    placeholder: {
      type: String,
      required: true,
    },

    value: {
      type: Object,
      default: ()=>({}),
    },
  },

  data: () => ({
    items: [],

    rules: {
      required: value => !!value || "Esse campo deve ser preenchido"
    }
  }),

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  mounted(){
    this.load()
  },

  methods: {
    load() {
      enderecoService.listAllStates().subscribe((res)=>{
        this.items = res
      })
    }
  }
}
</script>
